import { render, staticRenderFns } from "./LocaleSearch.vue?vue&type=template&id=32855413&"
import script from "./LocaleSearch.vue?vue&type=script&lang=ts&"
export * from "./LocaleSearch.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports